module.exports = __webpack_public_path__ + "img/idea_img2.2a16c78e.png";